import React, { FC } from 'react'
import styled from 'styled-components'
import { animatedLoadingEffect } from 'uiComponents/constants/animations'
import {
  backgroundColor,
  complementaryColor,
} from 'uiComponents/constants/colors'

export const FallbackWrapper = styled.section`
  cursor: default;
  display: block;
  overflow: hidden;
  position: relative;
  z-index: 0;
  background: ${complementaryColor};
`

const FallbackImage = styled.div`
  position: relative;
  width: 100%;
  border-radius: 2px;
  background-color: ${backgroundColor};
  height: 0;
  padding-top: 133%;
  overflow: hidden;
  ${animatedLoadingEffect};
`

const FallbackContent = styled.div`
  padding: 15px 15px 50px;
  margin-bottom: -35px;
  line-height: 1.4em;
  background: inherit;
  z-index: 1;
`

const FallbackName = styled.p`
  background-color: ${backgroundColor};
  overflow: hidden;
  height: 16px;
  width: 35%;
  margin-bottom: 6px;
  ${animatedLoadingEffect};
`
const FallbackPrice = styled.p`
  background-color: ${backgroundColor};
  overflow: hidden;
  height: 16px;
  width: 25%;
  ${animatedLoadingEffect};
`

export const FallbackSkeleton: FC = () => {
  return (
    <FallbackWrapper>
      <FallbackImage />
      <FallbackContent>
        <FallbackName />
        <FallbackPrice />
      </FallbackContent>
    </FallbackWrapper>
  )
}
